module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Fale com quem é o proprietário dessa conta","subtitle":"A validação precisa ser feita na conta de um perfil de proprietário.","button":"Voltar para Empresas"},"en-US":{"title":"Speak to whoever owns this account","subtitle":"Validation needs to be done on an owner profile account.","button":"Back to Companies"}}')
  delete Component.options._Ctor
}
